import { useAppContainerProps } from "./AppContainer";
import { AuthenticationService } from "./GeneralServices/AuthenticationService";
import { CommentFormService } from "./GeneralServices/CommentFormService";
import { PortalService } from "./GeneralServices/PortalService";
import { useVisitorTracker } from "./Main/VisitorTracker";
import ImpersonationIndicator from "./Impersonation/ImpersonationIndicator";
import PrivacyCookieConsentManager from "./Privacy/PrivacyCookieConsentManager";
import ExternalLinksManager from "./Utils/ExternalLinksManager";

const AppInner = ({ children }) => {
  const { enableGdprBanner, impersonating } = useAppContainerProps();

  useVisitorTracker();

  return (
    <>
      <PortalService>
        <AuthenticationService>
          <CommentFormService>
            <ExternalLinksManager>
              {impersonating && <ImpersonationIndicator />}

              {enableGdprBanner && <PrivacyCookieConsentManager />}

              {children}
            </ExternalLinksManager>
          </CommentFormService>
        </AuthenticationService>
      </PortalService>
    </>
  );
};

export default AppInner;
